import {
    AliceAgentAppDTO,
    AliceAgentAppListItem,
    CreateAliceAgentAppRequest,
    CreateAliceAgentAppResponse,
    McpObserveRequest,
    McpObserveResponse,
    UpdateAliceAgentAppRequest,
} from 'client/model/aliceAgentApp';

import { routes } from '../../lib/routes';
import { callApi } from '../utils';

const basePath = (skillId?: string) => `/v3/alice-agent-apps${skillId ? `/${skillId}` : ''}`;

export const createAliceAgentApp = (request: CreateAliceAgentAppRequest) =>
    callApi<CreateAliceAgentAppResponse>({
        method: 'POST',
        url: routes.app.appStoreApi(basePath()),
        data: request,
    });

export const listAliceAgentApps = () =>
    callApi<AliceAgentAppListItem[]>({
        method: 'GET',
        url: routes.app.appStoreApi(basePath()),
    });

export const getAliceAgentApp = (skillId: string) =>
    callApi<AliceAgentAppDTO>({
        method: 'GET',
        url: routes.app.appStoreApi(basePath(skillId)),
    });

export const updateAliceAgentApp = (skillId: string, request: UpdateAliceAgentAppRequest) =>
    callApi<void>({
        method: 'PATCH',
        url: routes.app.appStoreApi(basePath(skillId)),
        data: request,
    });

export const publishAliceAgentApp = (skillId: string) =>
    callApi<void>({
        method: 'POST',
        url: routes.app.appStoreApi(`${basePath(skillId)}/publish`),
    });

/**
 * Probes the MCP server for the given draft AND records the connection fingerprint on
 * success (sets `manifest.config.mcp.verified=true` on the draft). Tools/resources/publish are
 * gated on this flag — any subsequent change to connection fields resets it server-side.
 */
export const observeMcp = (skillId: string, request: McpObserveRequest) =>
    callApi<McpObserveResponse>({
        method: 'POST',
        url: routes.app.appStoreApi(`${basePath(skillId)}/observe-mcp`),
        data: request,
    });

export interface AliceAgentAppImageDTO {
    id: string;
    url: string;
}

export const uploadAliceAgentAppLogo = (skillId: string, file: File) => {
    const data = new FormData();
    data.append('file', file);
    return callApi<AliceAgentAppImageDTO>({
        method: 'POST',
        url: routes.app.appStoreApi(`${basePath(skillId)}/logo`),
        data,
    });
};
